/** Tokens visuales Movex — marketing + panel admin */
export const MOVEX_UI = {
  pageBg: '#F4F6FA',
  heroGradient: 'linear-gradient(135deg, #050505 0%, #0f172a 42%, #0a2e1a 100%)',
  cardBg: '#FFFFFF',
  cardBorder: 'rgba(15, 23, 42, 0.08)',
  cardShadow: '0 8px 32px rgba(15, 23, 42, 0.06)',
  cardShadowHover: '0 16px 40px rgba(6, 200, 109, 0.18)',
  accent: '#06C86D',
  accentDark: '#0CAB03',
  accentSoft: 'rgba(6, 200, 109, 0.12)',
  muted: '#64748B',
  text: '#0f172a',
  timelineGradient: 'linear-gradient(180deg, #06C86D 0%, #22d3ee 55%, rgba(124,92,255,0.5) 100%)',
  radiusLg: '24px',
  radiusMd: '16px',
  radiusPill: '999px',
};

export const proseSx = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  color: MOVEX_UI.muted,
  fontSize: 16,
  lineHeight: 1.75,
  '& p': { mb: 2 },
  '& ul, & ol': { pl: 3, mb: 2 },
  '& li': { mb: 0.75 },
  '& a': { color: MOVEX_UI.accentDark, fontWeight: 600, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } },
  '& strong': { color: MOVEX_UI.text },
};

export const pillButtonSx = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  textTransform: 'none',
  fontWeight: 700,
  borderRadius: MOVEX_UI.radiusPill,
  px: 3.5,
  py: 1.2,
  boxShadow: 'none',
};
